const dunsNumberRegex = /^\d{9}$/;

export const normalizeDunsNumber = (value: string): string => value.replace(/[\s-]/g, "");

export const isValidDunsNumber = (value: string): boolean =>
  dunsNumberRegex.test(normalizeDunsNumber(value));
